import { DuotoneIcon, OrganizationIcon, UsersIcon } from '@atoms/icons';

export const onboardingItems = [
  {
    id: 'organization',
    icon: <OrganizationIcon active />,
    titleKey: 'dashboard.widgets.onboarding.organization.title',
    subtitleKey: 'dashboard.widgets.onboarding.organization.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.organization.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/settings/organization/details',
  },
  {
    id: 'qualifications',
    icon: <DuotoneIcon name="notes-medical" active />,
    titleKey: 'dashboard.widgets.onboarding.qualifications.title',
    titleAlternativeKey: 'dashboard.widgets.onboarding.qualifications.titleAlternative',
    subtitleKey: 'dashboard.widgets.onboarding.qualifications.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.qualifications.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/settings/qualifications-specialties',
  },
  {
    id: 'departments',
    icon: <DuotoneIcon name="notes-medical" active />,
    titleKey: 'dashboard.widgets.onboarding.departments.title',
    titleAlternativeKey: 'dashboard.widgets.onboarding.departments.titleAlternative',
    subtitleKey: 'dashboard.widgets.onboarding.departments.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.departments.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/settings/departments',
  },
  {
    id: 'locations',
    icon: <DuotoneIcon name="map-location-dot" active />,
    titleKey: 'dashboard.widgets.onboarding.locations.title',
    titleAlternativeKey: 'dashboard.widgets.onboarding.locations.titleAlternative',
    subtitleKey: 'dashboard.widgets.onboarding.locations.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.locations.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/settings/locations',
  },
  {
    id: 'users',
    icon: <UsersIcon active />,
    titleKey: 'dashboard.widgets.onboarding.users.title',
    titleAlternativeKey: 'dashboard.widgets.onboarding.users.titleAlternative',
    subtitleKey: 'dashboard.widgets.onboarding.users.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.users.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/settings/users',
  },
  {
    id: 'providers',
    icon: <DuotoneIcon name="user-doctor" active />,
    titleKey: 'dashboard.widgets.onboarding.providers.title',
    titleAlternativeKey: 'dashboard.widgets.onboarding.providers.titleAlternative',
    subtitleKey: 'dashboard.widgets.onboarding.providers.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.providers.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/providers',
  },
  {
    id: 'staffingPartners',
    icon: <DuotoneIcon name="handshake" active />,
    titleKey: 'dashboard.widgets.onboarding.staffingPartners.title',
    subtitleKey: 'dashboard.widgets.onboarding.staffingPartners.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.staffingPartners.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/staffing-partners',
  },
  {
    id: 'shifts',
    icon: <DuotoneIcon name="list-timeline" active />,
    titleKey: 'dashboard.widgets.onboarding.schedule.title',
    subtitleKey: 'dashboard.widgets.onboarding.schedule.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.schedule.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/schedule',
  },
  {
    id: 'billing',
    icon: <DuotoneIcon name="list-timeline" active />,
    titleKey: 'dashboard.widgets.onboarding.billing.title',
    subtitleKey: 'dashboard.widgets.onboarding.billing.subtitle',
    subtitleLongKey: 'dashboard.widgets.onboarding.billing.subtitleLong',
    actionButtonLabel: 'dashboard.widgets.onboarding.widget.getStarted',
    actionLink: '/billing',
  },
];
